import React, { useState } from "react";
import { brandIcons } from "../utils/brands/brandsIcons";

interface IBrandProps {
  logo: string;
  text: string;
  clicked?: boolean;
  onClick?: () => void;
}

const Brand = ({ logo, text, clicked, onClick }: IBrandProps) => {
  return (
    <button
      onClick={onClick}
      className={`btn btn-large btn-brand ${clicked && "btn-brand-clicked"}`}
    >
      <span>
        <img src={brandIcons[logo]} />
        <h5>{text}</h5>
      </span>
    </button>
  );
};

export default Brand;
